import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Row } from "antd";
import { theme, MixStyle } from "../../styles";
import AllContractList from "../../components/ContractList";
import { updateCurrentPath } from "../../redux/Action/pageRoot";

import { BreadCrumbBox, Button, Grid, Section } from "../../core";
const { buttonBg } = theme;
const BtnProps = {
  width: "143px",
  height: "30px",
  margin: "5px",
  bg: buttonBg.tertiary,
};
const LinkBtn = styled(Link)`
  ${MixStyle.Link};
`;
const StyledBreadCrumb = styled(BreadCrumbBox)`
  ${MixStyle.flexArround}
`;
const ContractList = () => {
  const dispatch = useDispatch();
  dispatch(updateCurrentPath("Contract", "Contract List"));
  return (
    <Grid>
      <StyledBreadCrumb backlink={false} tittle="Contarct Details">
        <Row type="flex" justify="center">
          <Button {...BtnProps}>
            <LinkBtn to="/yarn-history">Yarn History</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="dispatch-list">Dispatch History</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="/buyer-list">Buyer List</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="addBuyer">Add Buyer</LinkBtn>
          </Button>
          <Button {...BtnProps}>
            <LinkBtn to="add-contract">Add Contract</LinkBtn>
          </Button>
        </Row>
      </StyledBreadCrumb>
      <Section>
        <Grid>
          {/* <FilterWraper> */}
          <Grid>
            <AllContractList />
          </Grid>
          {/* </FilterWraper> */}
        </Grid>
      </Section>
    </Grid>
  );
};

export default ContractList;
